import { ArrowUpRight } from "lucide-react";

// "Our family of companies" (Aziz, Oct 19) — eight links, copy verbatim from the owner, every link opens in a new tab.
export const FAMILY_COMPANIES = [
  { id: "arcadeops", name: "ArcadeOps", domain: "arcadeops.net", href: "https://arcadeops.net", blurb: "Fortune cabinets, AOG Sweeps game kiosks and route services" },
  { id: "jio-force", name: "Jio Force", domain: "jioforce.com", href: "https://jioforce.com", blurb: "Sales platform for insurance agencies and brokerages" },
  { id: "jio-first-insurance", name: "Jio First Insurance", domain: "jiofirst.com", href: "https://jiofirst.com", blurb: "Business insurance" },
  { id: "jio-first-properties", name: "Jio First Properties", domain: "jioforce.com", href: "https://jioforce.com", blurb: "Real estate brokerage" },
  { id: "servicepilot", name: "ServicePilot", domain: "servicepilot.solutions", href: "https://servicepilot.solutions", blurb: "Book trusted local home service pros" },
  { id: "freighthub-portal", name: "FreightHub Portal", domain: "freighthubportal.com", href: "https://freighthubportal.com", blurb: "Freight and shipping portal" },
  { id: "phone-play", name: "Phone Play", domain: "phoneplay.net", href: "https://phoneplay.net", blurb: "Free games" },
  { id: "holo-answers", name: "Holo Answers", domain: "callholo.com", href: "https://callholo.com", blurb: "AI phone answering for businesses" },
];

export default function FamilyOfCompaniesSection() {
  return (
    <section id="family-of-companies" className="border-t border-border/60 bg-card/20 scroll-mt-20" data-testid="family-of-companies-section">
      <div className="max-w-7xl mx-auto px-4 py-12 sm:py-14">
        <div className="font-mono text-[10px] uppercase tracking-[0.28em] text-neon-cyan">Family</div>
        <h2 className="mt-2 font-heading font-black text-base md:text-lg text-white" data-testid="family-of-companies-title">Our family of companies</h2>
        <ul className="mt-6 grid gap-3 sm:grid-cols-2 lg:grid-cols-4" data-testid="family-of-companies-list">
          {FAMILY_COMPANIES.map((c, i) => (
            <li key={c.id} className="rise" style={{ animationDelay: `${i * 60}ms` }}>
              <a href={c.href} target="_blank" rel="noopener noreferrer" data-testid={`family-company-${c.id}`}
                 className="group flex h-full flex-col border border-border/70 bg-black/30 p-4 hover:border-neon-cyan transition-colors">
                <div className="flex items-start justify-between gap-2">
                  <span className="font-heading font-bold text-foreground group-hover:text-neon-cyan transition-colors" data-testid={`family-company-${c.id}-name`}>{c.name}</span>
                  <ArrowUpRight className="w-4 h-4 shrink-0 text-white/40 group-hover:text-neon-cyan transition-colors" />
                </div>
                <div className="mt-0.5 font-mono text-[10px] uppercase tracking-widest text-white/45">{c.domain}</div>
                <p className="mt-2 text-sm text-white/65 leading-relaxed" data-testid={`family-company-${c.id}-blurb`}>{c.blurb}</p>
              </a>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
